import styled from 'styled-components';

export const Container = styled.div`
  position: absolute;
  bottom: calc(100% + 25px);
  right: 50%;
  transform: translateX(50%);
  z-index: 1000;
  padding: .4rem;
  border-radius: 10px;
  background-color: #505061;

  /* Seta do tooltip */
  &::after {
    content: '';
    position: absolute;
    top: 99%;
    right: 50%;
    transform: translateX(50%);
    border: 8px solid transparent;
    border-top-color: #505061;
  }

  .span--{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 2rem;
    color: #00a884;
  };
  .cursor--pointer{
    cursor: pointer;
  }
`;

export const Content = styled.div`
  display: ${({ isOpen }) => isOpen ? 'flex' : 'none'};
  width: 27rem;
  height: 27rem;
  border-radius: 6px;
  background-color: #ffffff;
  box-shadow: 0 2px 4px -1px rgb(0 0 0 / 20%), 0 4px 5px 0 rgb(0 0 0 / 14%), 0 1px 10px 0 rgb(0 0 0 / 12%);
  cursor: auto;
  flex-direction: column;
  overflow: hidden;
  
  .close{
    display: flex;
    width: 100%;
    height: 2.5rem;
    justify-content: flex-end;
    padding: 0.5rem;

    .icon{
      cursor: pointer;
      font-size: 1.3rem;
    }
  }

  .options{
    display: flex;
    width: 100%;
    height: 3rem;
    border-bottom: 1px solid #dee2e6;
    cursor: pointer;

    span{
      width: 50%;
      display: flex;
      font-size: 1rem;
      justify-content: center;
      align-items: center;
      color:black;
      gap: 0.5rem;
    }
    

    .select{
      color: #ffff;
      background-color: #1983e2;
    }

  }

  .body{
    display: flex;
    width: 100%;
    height: 100%;
  }
`;